import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Route } from 'react-router-dom';
import _ from 'lodash';
import { Accordion } from 'core/controls';
import { TranslateContext } from 'core/translate';
import ScrollTop from '../common/ScrollTop';
import PackageOptionGroup from './PackageOptionGroup';
import PackageDetails from './details/PackageDetails';
import { useModelInfo } from '../common/ModelInfoContext';
import { toggleOption } from '../store/actions';

const pathname = '/packages';

const Packages = ({ packageGroups, onChange, options }) => {
  const modelInfo = useModelInfo();
  const qualified = _.find(packageGroups, x => x.id === 'qualified');

  const morePackageHeader = !qualified
    ? 'component.common.select.packages'
    : 'package.more';

  const cashAllowanceSelected = _.some(qualified, 'selected');

  return (
    <ScrollTop>
      <Accordion>
        <TranslateContext.Consumer>
          {translate =>
            packageGroups.map(group => (
              <PackageOptionGroup
                key={group.id}
                header={translate(
                  group.id === 'more' ? morePackageHeader : group.id
                )}
                options={group.options}
                cashAllowanceSelected={cashAllowanceSelected}
                onChange={onChange}
              />
            ))
          }
        </TranslateContext.Consumer>
      </Accordion>
      <Route
        path="/packages/package/:id"
        render={({ match, history }) => {
          const { id } = match.params;

          return (
            <PackageDetails
              onClose={() => {
                history.push(pathname);
              }}
              packageId={id}
              option={options[id]}
              isLite={modelInfo.isLiteRenderMode}
              onSelect={option => {
                history.push(pathname);
                onChange(option);
              }}
            />
          );
        }}
      />
    </ScrollTop>
  );
};

const mapStateToProps = state => {
  const { packages, options } = state.config;
  return {
    packageGroups: packages,
    options
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onChange: option => dispatch(toggleOption(option))
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Packages)
);
